module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div name=\"form-content\" class=\"wh100 spl-webservice-form\">\n    ")
    ;  if (check("Spatial.Providers", Security.AccessMode.Insert) || check("Spatial.Providers", Security.AccessMode.Update)) { 
    ; __append("\n    <div class=\"form__buttons padding__medium clearfix\">\n        <div class=\"left\">\n            <div class=\"icon-20 icon-mode_edit gl-pointer button\" title=\"Редактировать\" on-click=\"onEditClick\"></div>\n        </div>\n\n        <div class=\"right\" name=\"editor-buttons\" style=\"display: none\">\n            <div name=\"save\" class=\"icon-20 icon-check gl-pointer button\" title=\"Сохранить\" on-click=\"onSaveClick\"></div>\n            <div name=\"cancel\" class=\"icon-20 icon-close gl-pointer button\" title=\"Отмена\" on-click=\"onCancelClick\"></div>\n        </div>\n    </div>\n    ")
    ;  } 
    ; __append("\n    <div class=\"padding__lr-5\">\n        <div name=\"page\" class=\"wh100 overflow-y__auto\"></div>\n    </div>\n</div>")
  }
  return __output.join("");

}